export enum $formFields {
  message = 'message',
  screenshot = 'screenshot',
  recommendation = 'recommendation',
  internal = 'internal',
}
